// @ts-nocheck

// import PropTypes from 'prop-types';

import React from 'react';
import styled, { css } from 'styled-components';

import { ReactComponent as Columns } from '../../assets/svg/columns.svg';
import { Target } from '../../client';
import { MultiviewButton } from '../../styled-components/shared';

const SelectorWrapper = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;
  height: 30px;
  padding: 0 0 5px 0;
`;

const OptionButton = styled(MultiviewButton)`
  && {
    flex: 1 1 auto;
    background-color: ${(p) => (p.active ? p.theme.common.colors.dark : p.theme.common.colors.light)};
    color: ${(p) => (p.active ? '#fff' : p.theme.common.colors.dark)};
    border-radius: 0;
    padding: 0;

    ${Target.__MOBILE__
      ? undefined
      : css`
          &:hover {
            background-color: ${({ theme }) => theme.common.colors.dark};
            color: #fff;
          }
        `}
  }
`;

const LikeOption = styled.div`
  position: relative;
  flex: 1 1 auto;
  background-color: ${({ theme }) => theme.common.colors.light} !important;
  text-align: center;
`;

const ColumnIcon = styled(Columns)`
  position: absolute;
  width: 14px;
  height: 14px;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
`;

type MultiviewControllerProps = {
  userOption: number;
  itemPerLine: number;
  displayOptions: Array<number>;
  setUserOption: (...params: unknown) => unknown;
};

const MultiviewController = ({ userOption, itemPerLine, displayOptions, setUserOption }: MultiviewControllerProps) => {
  const onClick = (option) => () => {
    setUserOption(option);
  };

  const bestItemPerLine = userOption > itemPerLine ? itemPerLine : userOption;
  const filteredDisplayOptions = displayOptions.filter((option) => option <= itemPerLine);

  return (
    <SelectorWrapper>
      <LikeOption>
        <ColumnIcon id="columns-icon" title="columns" />
      </LikeOption>
      {filteredDisplayOptions.map((option) => (
        <OptionButton
          key={`filteredDisplayOptions-${option}`}
          active={bestItemPerLine === option}
          onClick={onClick(option)}
        >
          {option}
        </OptionButton>
      ))}
    </SelectorWrapper>
  );
};

export default MultiviewController;
